import { AxiosResponseType, ReportViewType } from '@/shared/types'
import { REPORT_VIEW } from '@/shared/constants'
import {
  reportApi,
  periodontalReportApi,
  screeningReportApi,
  brushReportApi,
} from '@/shared/api'

export const submitReport = async (
  reportType: ReportViewType,
  reportId: number,
  sendCommentFiles: boolean
): AxiosResponseType<any> => {
  if (reportType === REPORT_VIEW.plaqueIndex) {
    return await reportApi.sendEmail(reportId, sendCommentFiles)
  }

  if (reportType === REPORT_VIEW.periodontal) {
    return await periodontalReportApi.sendEmail(reportId, sendCommentFiles)
  }

  if (reportType === REPORT_VIEW.screening) {
    return await screeningReportApi.sendEmail(reportId, sendCommentFiles)
  }

  if (reportType === REPORT_VIEW.brushMap) {
    return await brushReportApi.sendEmail(reportId, sendCommentFiles)
  }
}
